import Vue from '../../../plugins/vueFactory';
import { currentTimestampSeconds, numberOfItemsInShoppingCart } from '../utils';

export default {
  resetShoppingCart(state) {
    state.numberOfItemsInShoppingCart = undefined;
    state.shoppingCartLastRefreshedTimestamp = undefined;
  },
  setShoppingCart(state, payload) {
    state.shoppingCart.orderable = payload.orderable;
    state.shoppingCart.productsSubtotal = payload.products_subtotal;
    state.shoppingCart.requestedDeliveryDate = payload.requested_delivery_date;
    state.shoppingCart.shoppingCartId = payload.shopping_cart_id;
    state.shoppingCart.subtotal = payload.subtotal;
    state.shoppingCart.totalPrice = payload.total_price;
    state.shoppingCart.vat = payload.vat;

    Vue.set(
      state.shoppingCart,
      'additionalCosts',
      payload.additional_costs?.map((x) => ({
        description: x.description,
        price: x.price,
        additionalInfo: x.additional_info
      }))
    );

    Vue.set(
      state.shoppingCart,
      'additionalCosts2',
      payload.additional_costs_2?.map((x) => ({
        description: x.description,
        price: x.price,
        additionalInfo: x.additional_info
      }))
    );

    Vue.set(
      state.shoppingCart,
      'baseShapes',
      payload.base_shapes?.map((x) => ({
        baseShape: x.base_shape,
        productImage: x.product_image,
        teaserDescription: x.teaser_description,
        messages: x.messages?.map((y) => ({
          message: y.message,
          severity: y.severity
        })),
        products: x.products.map((y) => ({
          productCode: y.product_code,
          longDescription: y.long_description,
          priceEach: y.price_each,
          discount: y.discount,
          quantity: y.quantity,
          quantityReadOnly: y.quantity_read_only,
          subtotal: y.subtotal,
          delivery: y.delivery ?? {}
        }))
      }))
    );

    Vue.set(
      state.shoppingCart,
      'messages',
      payload.messages?.map((x) => ({
        message: x.message,
        severity: x.severity
      }))
    );

    state.numberOfItemsInShoppingCart = numberOfItemsInShoppingCart(
      state.shoppingCart.baseShapes
    );

    state.shoppingCartLastRefreshedTimestamp = currentTimestampSeconds();
  }
};
